import { useState } from 'react';
import { toast } from 'react-toastify';
import api, { MainDomain } from 'api';
import './forgot-password.scss';

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const doForgotPassword = async () => {
        if (!email) { toast.warning("Email cannot be empty"); return; }

        try {
            setLoading(true);
            const data = await api.user.forgotPassword(email);
            setLoading(false);
            if (data.ok) {
                toast.success("Forgot password link sent to " + email);
                setEmail("");
                setTimeout(() => {
                    window.location.replace(process.env.PUBLIC_URL + "/login");
                }, 3000);
            } else {
                toast.error("Error occured sending forgot password to " + email); return;
            }
        } catch (err: any) {
            toast.error(err.toString());
            setLoading(false);
        }
    }

    const onFocus = (e: any) => {
        e.target.removeAttribute("readonly");
    }

    const onKeyUp = (e: any) => {
        if (e.key === "Enter") {
            doForgotPassword();
        }
    }

    return (
        <div className="forgot-password container">
            <div>
                <div className="logo-section">
                    <span className="logo-detail">Workflow</span>
                    {MainDomain}
                </div>
            </div>
            <div>
                <h2>FORGOT PASSWORD</h2>
                <input type="email" placeholder="Email" onChange={(e: any) => setEmail(e.target.value)} readOnly onFocus={onFocus} onKeyUp={onKeyUp} />
                <button onClick={doForgotPassword}>{!loading ? 'SUBMIT' : <i className="fal fa-spinner fa-spin"></i>}</button>
            </div>
        </div>
    )
}

export default ForgotPassword;